import type { RouteRecordRedirect } from 'vue-router'

type IOldRouteWithRedirect = {
  name: string
  path: string
  redirect: RouteRecordRedirect['redirect']
}

export const getOldRouteWithRedirect = (name: string, path: string, newRouteName: string): IOldRouteWithRedirect => {
  return {
    name,
    path,
    redirect: (to) => ({ name: newRouteName, params: to.params, query: to.query, hash: to.hash }),
  }
}
